<template>
  <div>
    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
          </div>
          <div>
            <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="col-videocate-title text-left">標題</th>
          <th class="text-left">群組</th>
          <th class="text-left">顯示/隱藏</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in videocateList"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>{{ item.title }}</td>
          <td>{{ item.support_category.title }}</td>
          <td>
            <FormSwitch v-model="item.status"
                        @changeStatus="toggleStatus(item.id)"></FormSwitch>
          </td>
          <td>
            <button class="btn square" @click="toVideoCateEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="get_videocateList" model="videocate"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    FormSwitch,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
  }),
  computed: {
    ...mapState('videocate', ['videocateList']),
    lengthOfisCheckedList() {
      return this.videocateList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.videocateList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.videocateList.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.videocateList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.videocateList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('videocate', {
      get_videocateList: 'find',
      destroyVideoCate: 'destroy',
      clear: 'clear',
      changeStatus: 'changeStatus',
    }),
    toVideoCateEdit(id) {
      this.$router.push({
        name: 'VideoCateEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.videocateList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.videocateList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyVideoCate(id).then(() => {
        this.get_videocateList();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyVideoCate(id).then(() => {});
      });
      this.get_videocateList();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.get_videocateList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.get_videocateList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-videocate-title {
    width: 250px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
